import React from 'react';

export interface InputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  placeholder?: string;
  children?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  function _Input(
    {
      label = '',
      children,
      rightIcon,
      className = '',
      onChange,
      placeholder,
      fullWidth,
      ...props
    },
    ref
  ) {
    return (
      <label className={`block ${fullWidth ? 'w-full' : ''}`}>
        {label !== '' ? (
          <span className="text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ">
            {label}
          </span>
        ) : null}
        <div
          className={`w-full border-[0.5px] border-solid border-neutral-300 rounded flex items-center py-2 px-3 gap-4 ${className}`}
        >
          {children}
          <input
            className={`${
              label !== '' ? ' ' : ''
            } focus:ring-0 border-none appearance-none h-6 bg-transparent outline-none focus:outline-none focus:shadow-none w-full placeholder:text-neutral-400 text-text-black tracking-wider p-0 ${className}`}
            ref={ref}
            onChange={onChange}
            placeholder={placeholder}
            {...props}
          />
          {rightIcon}
        </div>
      </label>
    );
  }
);
